
const matchManage = {
  path: '/match-manage',
  name: 'MatchManage',
  component: () => import('@/views/match-manage/index'),
  children: [
    {
      path: 'match-detail/:unionMatchId',
      name: 'MatchDetailId',
      component: () => import('@/views/match-manage/match-detail'),
      meta: { title: '管理赛事' }
    },
    {
      path: 'match-group/:unionMatchId',
      name: 'MatchGroupId',
      component: () => import('@/views/match-manage/match-group'),
      meta: { title: '组别列表' }
    },
    {
      path: 'match-list/:unionMatchId',
      name: 'MatchListId',
      component: () => import('@/views/match-manage/match-list'),
      meta: { title: '比赛列表' }
    },
    {
      path: 'create-game',
      name: 'CreateGame',
      component: () => import('@/views/match-manage/create-game'),
      meta: { title: '比赛创建/编辑' }
    },
    {
      path: 'team-list',
      name: 'TeamList',
      component: () => import('@/views/match-manage/team-list'),
      meta: { title: '选择队伍' }
    },
    {
      path: 'referee-list',
      name: 'RefereeList',
      component: () => import('@/views/match-manage/referee-list'),
      meta: { title: '选择裁判' }
    },
    {
      path: 'game-nature',
      name: 'GameNature',
      component: () => import('@/views/match-manage/game-nature'),
      meta: { title: '比赛性质' }
    },
    {
      path: 'score-entry/:unionMatchId',
      name: 'ScoreEntry',
      component: () => import('@/views/match-manage/score-entry'),
      meta: { title: '比分录入' }
    },
    {
      path: 'baseball-score/:gameId',
      name: 'BaseballScore',
      component: () => import('@/views/match-manage/baseball/baseball-score'),
      meta: { title: '比分录入' }
    },
    {
      path: 'game-statistics',
      name: 'GameStatistics',
      component: () => import('@/views/match-manage/game-statistics'),
      meta: { title: '技术统计' }
    },
    {
      path: 'football-statistics',
      name: 'FootballStatistics',
      component: () => import('@/views/match-manage/football/football-statistics'),
      meta: { title: '技术统计' }
    },
    {
      path: 'football-collect',
      name: 'FootballCollect',
      component: () => import('@/views/match-manage/football/football-collect'),
      meta: { title: '技术统计汇总' }
    },
    {
      path: 'football-time-line',
      name: 'FootballTimeLine',
      component: () => import('@/views/match-manage/football/football-time-line'),
      meta: { title: '事件时间轴' }
    },
    {
      path: 'collect',
      name: 'Collect',
      component: () => import('@/views/match-manage/collect'),
      meta: { title: '技术统计汇总' }
    },
    {
      path: 'apply-list/:unionMatchId',
      name: 'ApplyList',
      component: () => import('@/views/match-manage/apply/list'),
      meta: { title: '参赛列表' }
    },
    {
      path: 'apply-team',
      name: 'ApplyTeam',
      component: () => import('@/views/match-manage/apply/team'),
      meta: { title: '队伍编辑' }
    },
    {
      path: 'apply-player',
      name: 'ApplyPlayer',
      component: () => import('@/views/match-manage/apply/player'),
      meta: { title: '队员编辑' }
    },
    {
      path: 'match-manager/:unionMatchId',
      name: 'MatchManager',
      component: () => import('@/views/match-manage/match-manager'),
      meta: { title: '权限管理' }
    },
    {
      name: 'TennisScore',
      path: 'tennis-score',
      component: () => import('@/views/match-manage/tennis/tennis-score'),
      meta: { title: '比分录入' }
    },
    {
      name: 'TennisStatistics',
      path: 'tennis-statistics',
      component: () => import('@/views/match-manage/tennis/tennis-statistics'),
      meta: { title: '统计录入' }
    },
    {
      name: 'TennisCollect',
      path: 'tennis-collect',
      component: () => import('@/views/match-manage/tennis/tennis-collect'),
      meta: { title: '技术统计汇总' }
    },
    {
      path: 'rank-manage/:unionMatchId',
      name: 'RankManage',
      component: () => import('@/views/match-manage/rank/rank-manage'),
      meta: { title: '名次设置' }
    },
    {
      path: 'roll-call-setting/:unionMatchId',
      name: 'RollCallSetting',
      component: () => import('@/views/match-manage/roll-call-setting'),
      meta: { title: '检录范围设置' }
    },
    {
      path: 'record/:unionMatchId',
      name: 'Record',
      component: () => import('@/views/match-manage/record'),
      meta: { title: '检录记录' }
    },
    {
      path: 'result/:matchId',
      name: 'Result',
      component: () => import('@/views/match-manage/result'),
      meta: { title: '扫码检录' }
    },
    {
      path: 'set-player-card/:unionMatchId',
      name: 'SetPlayerCardOrderList',
      component: () => import('@/views/match-manage/set-player-card.vue'),
      meta: { title: '球员卡活动设置' }
    },
    {
      path: 'player-card-order-list/:unionMatchId',
      name: 'PlayerCardOrderList',
      component: () => import('@/views/match-manage/player-card-order-list.vue'),
      meta: { title: '球员卡订单列表' }
    },
    {
      path: 'order-detail',
      name: 'SaasOrderDetail',
      component: () => import('@/views/match-manage/order-detail.vue'),
      meta: { title: '球员卡订单详情' }
    },
    {
      path: 'match-player-card',
      name: 'MatchPlayerCard',
      component: () => import('@/views/match-manage/match-player-card.vue'),
      meta: { title: '球员卡' }
    },
    {
      path: 'scoring-table-list/:unionMatchId',
      name: 'ScoringTableList',
      component: () => import('@/views/match-manage/scoring-table/list.vue'),
      meta: { title: '记分台' }
    },
    {
      path: 'scoring-table-detail/:unionMatchId',
      name: 'ScoringTableDetail',
      component: () => import('@/views/match-manage/scoring-table/detail.vue'),
      meta: { title: '记分台详情' }
    },
    {
      path: 'volleyball-points/:unionMatchId',
      name: 'VolleyballPoints',
      component: () => import('@/views/match-manage/volleyball-points.vue'),
      meta: { title: '记分台' }
    },
    {
      path: 'volleyball-match-list/:unionMatchId',
      name: 'VolleyballMatchList',
      component: () => import('@/views/match-manage/volleyball-match-list.vue'),
      meta: { title: '比赛计划' }
    },
    {
      path: 'points-match-list/:unionMatchId',
      name: 'PointsMatchList',
      component: () => import('@/views/match-manage/points-match-list.vue'),
      meta: { title: '比赛计划' }
    },
    {
      path: 'add-scoring-form/:unionMatchId',
      name: 'AddScoringForm',
      component: () => import('@/views/match-manage/add-scoring-form.vue'),
      meta: { title: '新增记分台' }
    },
    {
      path: 'scoring-console/:unionMatchId',
      name: 'ScoringConsole',
      component: () => import('@/views/match-manage/scoring-console.vue'),
      meta: { title: '记分台' }
    },
    {
      path: 'football-scoring-console/:unionMatchId',
      name: 'ScoringConsole',
      component: () => import('@/views/match-manage/football-scoring-console.vue'),
      meta: { title: '记分台' }
    },
    {
      path: 'update-game/:unionMatchId',
      name: 'UpdateGame',
      component: () => import('@/views/match-manage/update-game.vue'),
      meta: { title: '比赛编辑' }
    },
    {
      path: 'wheel-battle/parent-create/:unionMatchId',
      name: 'WheelBattleParentCreate',
      component: () => import('@/views/match-manage/wheel-battle/parent-create.vue'),
      meta: { title: '创建比赛' }
    },
    {
      path: 'wheel-battle/parent-detail/:parentGameId',
      name: 'WheelBattleParentDetail',
      component: () => import('@/views/match-manage/wheel-battle/parent-detail.vue'),
      meta: { title: '比赛信息' }
    },
    {
      path: 'wheel-battle/team-edit/:parentGameId',
      name: 'WheelBattleTeamEdit',
      component: () => import('@/views/match-manage/wheel-battle/team-edit.vue'),
      meta: { title: '编辑出赛球队' }
    },
    {
      path: 'wheel-battle/score-entry/:parentGameId/:subMatchId',
      name: 'WheelBattleScoreEntry',
      component: () => import('@/views/match-manage/wheel-battle/score-entry.vue'),
      meta: { title: '录入比分' }
    },
    {
      path: 'wheel-battle/stats-entry/:parentGameId/:subMatchId',
      name: 'WheelBattleStatsEntry',
      component: () => import('@/views/match-manage/wheel-battle/stats-entry.vue'),
      meta: { title: '添加数据' }
    }
  ]
}

export default matchManage
